import { useTranslation } from 'react-i18next'

import ErrorPage from '../ErrorPage'

export const PageNotFound = (): JSX.Element => {
  const { t } = useTranslation('providers/router')

  return <ErrorPage cause={t('errors.route.notFound')} />
}
